/*! @azure/msal-common v13.3.0 2023-08-24 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.3.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
